
import inputSelect from '../multipleSelectCheckbox'

const commonMultipleSelectCheckbox = {
    install:function(Vue) {
        Vue.component('commonMultipleSelectCheckbox', inputSelect)
    }
}


// 导出该组件

export default commonMultipleSelectCheckbox